import React from "react";

const Requisition = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path className="u_fill"
              d="M22.704 26.814c-6.162 3.869-14.084 2.1-18.139-3.423C.704 18.133 1.252 10.642 5.87 5.913 10.402 1.272 17.914.694 23.348 4.529c5.416 3.821 7.457 11.738 3.503 18.143.13.09.262.182.394.271 1.91 1.284 3.802 2.596 5.484 4.171 1.16 1.087 1.531 2.467 1.092 3.983-.425 1.466-1.407 2.453-2.929 2.798-1.281.29-2.452-.027-3.417-.901a13.421 13.421 0 0 1-1.68-1.848c-.98-1.297-1.898-2.64-2.84-3.963-.082-.114-.159-.232-.25-.369Zm-7.31-5.082v-.001c1.682 0 3.364.01 5.045-.004.984-.009 1.583-.883 1.24-1.802-.169-.454-.355-.912-.6-1.328-.723-1.22-1.671-2.212-3.021-2.746a.859.859 0 0 0-.526-.03c-1.473.443-2.926.43-4.368-.13a.525.525 0 0 0-.366-.005c-1.83.806-3.123 2.12-3.75 4.037-.367 1.125.287 2.009 1.461 2.01l4.885-.001Zm3.562-11.726a3.565 3.565 0 0 0-3.6-3.582 3.573 3.573 0 0 0-3.588 3.595c-.005 2.104 1.77 3.541 3.637 3.577 1.964.038 3.556-1.599 3.551-3.59Z"
              fill={fill}
        />
    </svg>
);

export default Requisition;